import { z } from "zod";

export const extensionStatusResponseSchema = z.object({
  /**
   * ROUTING-ELIGIBILITY, not presence. True means the submission worker may
   * park work for the extension to claim — it is derived from `lastSeenAt`,
   * which only a real user-initiated claim advances. Do NOT widen this to
   * mean "the extension is installed"; use `isPresent` for that.
   */
  isReady: z.boolean(),
  lastSeenAt: z.string().datetime().nullable(),
  /**
   * PRESENCE — the extension is installed and its background tick is
   * reaching us. Derived from `lastHeartbeatAt`. Independent of `isReady`:
   * a correctly installed extension is `isPresent` long before (and long
   * after) it is `isReady`. Defaults to false for older server builds.
   */
  isPresent: z.boolean().default(false),
  lastHeartbeatAt: z.string().datetime().nullable().default(null),
  installId: z.string().nullable(),
  linkedinProfileId: z.string().nullable(),
  // PR-G/6 Confirm-to-Submit overlay gate. Defaults to true so older server
  // builds that don't yet emit this field don't break the extension.
  confirmToSubmitEnabled: z.boolean().default(true),
  // Spec 034 Phase 5 — the user's auto-apply tier quota, so the extension can
  // surface and enforce min(extension hard ceiling, tier quota). 0 = no quota
  // (FREE tier or no UsageLimit row).
  dailyApplyCap: z.number().int().nonnegative().default(0),
  hourlyApplyCap: z.number().int().nonnegative().default(0),
});

export type ExtensionStatusResponseDto = z.infer<typeof extensionStatusResponseSchema>;
